const btn = document.getElementById("download-tearsheet");

btn.addEventListener("click", generatePDF);

const LAYOUT = {

    image: {
        x: 113,
        y: 145,
        width: 387,
        height: 525
    },

    title: {
        x: 35,
        y: 113,
        size: 17
    },

    colorway: {
        x: 35,
        y: 101,
        size: 10
    },

    description: {
        x: 25,
        y: 74,
        width: 560,
        size: 9,
        lineHeight: 11
    }

};

async function generatePDF() {

    const raw = window.tearSheetData;

    const data = {
        title: String(raw.title || ""),
        colorway: Array.isArray(raw.colorway)
            ? raw.colorway.join(" / ")
            : String(raw.colorway || ""),
        description: String(raw.description || ""),
        image: raw.image.startsWith("//")
            ? "https:" + raw.image
            : raw.image
    };

    const existingPdf = await fetch(
        "https://cdn.shopify.com/s/files/1/0992/1491/7998/files/Rug_Tearsheet_Template_Blank.pdf?v=1784043738"
    ).then(r => r.arrayBuffer());

    const pdfDoc = await PDFLib.PDFDocument.load(existingPdf);

    const page = pdfDoc.getPages()[0];

    const font = await pdfDoc.embedFont(PDFLib.StandardFonts.Helvetica);

    const fontBold = await pdfDoc.embedFont(PDFLib.StandardFonts.HelveticaBold);

    const imageBytes = await fetch(data.image).then(r => r.arrayBuffer());

    let image;

    if (data.image.toLowerCase().includes(".png")) {
        image = await pdfDoc.embedPng(imageBytes);
    } else {
        image = await pdfDoc.embedJpg(imageBytes);
    }

    /////////////////////////////////////////////////
    // AUTO FIT IMAGE (keeps aspect ratio)
    /////////////////////////////////////////////////

    const imgWidth = image.width;
    const imgHeight = image.height;

    const scale = Math.min(
        LAYOUT.image.width / imgWidth,
        LAYOUT.image.height / imgHeight
    );

    const drawWidth = imgWidth * scale;
    const drawHeight = imgHeight * scale;

    const drawX =
        LAYOUT.image.x +
        (LAYOUT.image.width - drawWidth) / 2;

    const drawY =
        LAYOUT.image.y +
        (LAYOUT.image.height - drawHeight) / 2;

    page.drawImage(image, {
        x: drawX,
        y: drawY,
        width: drawWidth,
        height: drawHeight
    });

    /////////////////////////////////////////////////
    // TITLE
    /////////////////////////////////////////////////

    page.drawText(data.title.toUpperCase(), {
        x: LAYOUT.title.x,
        y: LAYOUT.title.y,
        size: LAYOUT.title.size,
        font: font
    });

    /////////////////////////////////////////////////
    // COLORWAY
    /////////////////////////////////////////////////

    page.drawText(data.colorway, {
        x: LAYOUT.colorway.x,
        y: LAYOUT.colorway.y,
        size: LAYOUT.colorway.size,
        font: font
    });

    /////////////////////////////////////////////////
    // DESCRIPTION
    /////////////////////////////////////////////////

    /////////////////////////////////////////////////
    // SAVE
    /////////////////////////////////////////////////

    const pdfBytes = await pdfDoc.save();

    const blob = new Blob(
        [pdfBytes],
        { type: "application/pdf" }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download = `Judy-Ross-${data.title}-Rug.pdf`;

    link.click();

    URL.revokeObjectURL(url);

}

/////////////////////////////////////////////////////
// WORD WRAP
/////////////////////////////////////////////////////

function wrapText(page, text, options) {

    const {
        x,
        y,
        width,
        font,
        fontSize,
        lineHeight
    } = options;

    const words = text.split(" ");

    let line = "";

    let yy = y;

    for (const word of words) {

        const testLine = line + word + " ";

        const textWidth =
            font.widthOfTextAtSize(
                testLine,
                fontSize
            );

        if (textWidth > width) {

            page.drawText(line.trim(), {
                x,
                y: yy,
                size: fontSize,
                font
            });

            line = word + " ";

            yy -= lineHeight;

        } else {

            line = testLine;

        }

    }

    if (line.trim() !== "") {

        page.drawText(line.trim(), {
            x,
            y: yy,
            size: fontSize,
            font
        });

    }

}